import React, { useState, useEffect } from 'react';
import '../../styles/AdminTable.scss';
import '../../styles/AdminForm.scss';

const AdminJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingJob, setEditingJob] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    department: '',
    description: '',
    requirements: '',
    location: 'Remote/Onsite',
    job_type: 'Full-time'
  });

  const getApiUrl = () => {
    const envUrl = process.env.REACT_APP_API_URL;
    if (typeof window !== 'undefined' && window.location) {
      const hostname = window.location.hostname;
      if (hostname && hostname !== 'localhost' && hostname !== '127.0.0.1') {
        return 'https://pravarainfotech.in/api';
      }
    }
    return envUrl || 'http://localhost:8000/api';
  };
  const API_BASE = getApiUrl();

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE}/jobs`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      }).catch(() => fetch(`${API_BASE}/jobs`));
      
      const data = await response.json();
      setJobs(data.data || []);
      setError('');
    } catch (err) {
      setError('Failed to load jobs');
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (job = null) => {
    if (job) {
      setEditingJob(job);
      setFormData(job);
    } else {
      setEditingJob(null);
      setFormData({
        title: '',
        department: '',
        description: '',
        requirements: '',
        location: 'Remote/Onsite',
        job_type: 'Full-time'
      });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingJob(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.title.trim() || !formData.department.trim() || 
        !formData.description.trim() || !formData.requirements.trim()) {
      setError('All fields are required');
      return;
    }

    try {
      const url = editingJob 
        ? `${API_BASE}/jobs/${editingJob.id}`
        : `${API_BASE}/jobs`;
      
      const method = editingJob ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setError('');
        setShowModal(false);
        fetchJobs(); // Refresh job list
        alert(editingJob ? 'Job updated successfully!' : 'Job created successfully!');
      } else {
        setError(data.detail || 'Failed to save job');
      }
    } catch (err) {
      setError('Error saving job');
      console.error('Error:', err);
    }
  };

  const handleDelete = async (jobId, jobTitle) => {
    if (window.confirm(`❗ Are you sure you want to DELETE "${jobTitle}"?\n\nThis job will be permanently removed from the Career page.`)) {
      try {
        const response = await fetch(`${API_BASE}/jobs/${jobId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.ok) {
          setError('');
          fetchJobs();
          alert('✅ Job deleted successfully!');
        } else {
          setError('Failed to delete job');
        }
      } catch (err) {
        setError('Error deleting job');
        console.error('Error:', err);
      }
    }
  };


  return (
    <div className="admin-page">
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px', marginBottom: '20px' }}>
        <div className="header-content">
          <h1>💼 We Are Hiring - Job Postings</h1>
          <p>Manage job openings and career opportunities</p>
        </div>
        <button className="btn-primary" onClick={() => handleOpenModal()}
          style={{ background: '#4f46e5', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' }}>
          ➕ Add New Job
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {/* Full-width table — no detail panel needed */}
      <div className="content-wrapper">
        <div className="table-container" style={{ width: '100%' }}>
          {loading ? (
            <p style={{ padding: '20px', textAlign: 'center' }}>Loading jobs...</p>
          ) : jobs.length === 0 ? (
            <p className="no-data" style={{ padding: '20px', textAlign: 'center', color: '#999' }}>No jobs found. Click "Add New Job" to create one.</p>
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>Job Title</th>
                  <th>Department</th>
                  <th>Location</th>
                  <th>Type</th>
                  <th>Posted</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {jobs.map((job) => (
                  <tr key={job.id}>
                    <td className="job-title"><strong>{job.title}</strong></td>
                    <td>{job.department}</td>
                    <td>{job.location}</td>
                    <td>
                      <span className="badge" style={{ backgroundColor: '#4169E1' }}>
                        {job.job_type}
                      </span>
                    </td>
                    <td>{new Date(job.created_at).toLocaleDateString()}</td>
                    <td className="actions">
                      <button
                        className="btn-edit"
                        onClick={() => handleOpenModal(job)}
                        title="Edit Job"
                        style={{ background: '#fff', border: '1px solid #ddd', padding: '6px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '16px' }}
                      >
                        ✏️
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => handleDelete(job.id, job.title)}
                        title="Delete Job"
                        style={{ background: '#fff3f3', border: '1px solid #ffcccc', color: '#dc2626', padding: '6px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '16px', marginLeft: '6px' }}
                      >
                        🗑️ Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>


        {/* Job Form Modal */}
        {showModal && (
          <div className="modal-overlay" onClick={handleCloseModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>{editingJob ? '✏️ Edit Job' : '➕ Add New Job'}</h2>
                <button className="btn-close" onClick={handleCloseModal}>✕</button>
              </div>

              <form onSubmit={handleSubmit} className="admin-form">
                <div className="form-group">
                  <label>Job Title *</label>
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    placeholder="e.g., Senior Software Engineer"
                    required
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Department *</label>
                    <input
                      type="text"
                      name="department"
                      value={formData.department}
                      onChange={handleChange}
                      placeholder="e.g., Development"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Location</label>
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                      placeholder="e.g., Remote/Onsite"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Job Type</label>
                    <select
                      name="job_type"
                      value={formData.job_type}
                      onChange={handleChange}
                    >
                      <option value="Full-time">Full-time</option>
                      <option value="Part-time">Part-time</option>
                      <option value="Contract">Contract</option>
                      <option value="Internship">Internship</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Job Description *</label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Describe the job role, responsibilities, and what we're looking for..."
                    rows="5"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Requirements *</label>
                  <textarea
                    name="requirements"
                    value={formData.requirements}
                    onChange={handleChange}
                    placeholder="List skills, experience, qualifications, etc."
                    rows="4"
                    required
                  />
                </div>

                <div className="form-actions">
                  <button type="button" className="btn-secondary" onClick={handleCloseModal}>
                    Cancel
                  </button>
                  <button type="submit" className="btn-primary">
                    {editingJob ? 'Update Job' : 'Create Job'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
  );
};

export default AdminJobs;
